import script from "./ScorePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ScorePanel.vue?vue&type=script&setup=true&lang=js"

import "./ScorePanel.vue?vue&type=style&index=0&id=616aa762&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616aa762"]])

export default __exports__